// Mock data for REFOCC - images served from local static files
export const ASSET = '/assets';
export const BRAND = '/brand';

export const heroSlides = [
  { img: `${ASSET}/summit-02.jpg`, kicker: 'Global Summit', title: 'A gathering of hearts, ideas, and changemakers across borders.', tag: 'Flagship', sub: 'REFOCC Global Summit, Dubai' },
  { img: `${ASSET}/group-photo.jpg`, kicker: 'REFOCC Team', title: 'Volunteers and leaders working together for lasting community impact.', tag: 'Movement', sub: 'India & the Gulf, side by side' },
  { img: `${ASSET}/gallery-22.jpg`, kicker: 'REFOCC Women', title: "A collective where women's voices, dreams, and contributions are celebrated.", tag: 'Women\'s Wing', sub: 'Leadership, expression & growth' },
];

export const stats = [
  { num: '10+', label: 'Years of service' },
  { num: '🌿', label: 'Kerala-rooted community movement' },
  { num: '🌍', label: 'Global community connections' },
  { num: '📚', label: 'Charity, culture, education & empowerment' },
];

export const pillars = [
  { title: 'Scholarship Programme', desc: 'Helping deserving students continue their education with timely support, encouragement, and community backing.', img: `${ASSET}/gallery-11.png`, href: '/scholarship' },
  { title: 'REFOCC Women', desc: "A platform for women's leadership, expression, wellbeing, skills, and collective growth.", img: `${ASSET}/gallery-22.jpg`, href: '/women' },
  { title: 'REYOCC — Youth', desc: 'A youth-led energy within REFOCC, mobilizing young people for service, culture, and leadership.', img: `${BRAND}/reyocc.jpg`, href: '/reyocc' },
];

export const events = [
  { tag: 'Cultural', title: 'REFOCC Decennial Scholars Award', when: 'Dhyuthi — 10th Anniversary Celebration', img: `${ASSET}/dyuthi-scholars-award.jpg`, desc: 'As part of REFOCC\'s 10th anniversary celebration Dhyuthi, the REFOCC Decennial Scholars Award offers a total scholarship fund of INR 10 lakh to support deserving students in continuing their education.', upcoming: true },
  { tag: 'Global Summit', title: 'REFOCC Global Summit', when: 'February 9–10, 2024 • Dubai, UAE', img: `${ASSET}/summit-01.jpg`, desc: 'A landmark gathering of REFOCC members and well-wishers, focused on unity, service, and future action.', link: 'https://fb.me/e/4L9UQL8d4' },
  { tag: "Women's Wing", title: "Women's Wing Gathering", when: '2023 • Mavoor, Kerala', img: `${ASSET}/gallery-22.jpg`, desc: "A space to celebrate women's leadership, stories, and contributions to the community." },
  { tag: 'Cultural', title: 'Cultural Meet', when: 'Annual • REFOCC Chapters', img: `${ASSET}/event-03.jpg`, desc: 'A celebration of heritage, togetherness, and the shared identity that connects the REFOCC family.' },
  { tag: 'Youth', title: 'Youth Volunteer Meet', when: 'Quarterly • REYOCC Chapters', img: `${ASSET}/gallery-35.jpg`, desc: 'A platform for young people to learn, organize, and lead community-centered initiatives.' },
  { tag: 'Charity', title: 'Community Support Drive', when: 'Ongoing • Kerala & Gulf', img: `${ASSET}/gallery-48.jpg`, desc: 'A practical outreach effort focused on timely support for families and individuals in need.' },
  { tag: 'Community', title: 'Community Gatherings', when: 'Regular • All Chapters', img: `${ASSET}/gallery-59.jpg`, desc: 'Regular gatherings that strengthen bonds and keep the community connected.' },
];

export const galleryCategories = [
  { title: 'Global Summit Moments', images: [`${ASSET}/summit-01.jpg`, `${ASSET}/summit-02.jpg`] },
  { title: 'REFOCC Team', images: [`${ASSET}/group-photo.jpg`, `${ASSET}/gallery-17.jpg`, `${ASSET}/gallery-23.jpg`] },
  { title: "Women's Wing", images: [`${ASSET}/gallery-22.jpg`, `${ASSET}/event-02.jpg`] },
  { title: 'Community Gatherings', images: [`${ASSET}/community-01.jpg`, `${ASSET}/community-02.jpg`, `${ASSET}/gallery-28.jpg`] },
  { title: 'Regional Chapters', images: [`${ASSET}/gallery-41.jpg`, `${ASSET}/gallery-53.jpg`, `${ASSET}/gallery-62.jpg`] },
  { title: 'Cultural and Charity Activities', images: [`${ASSET}/gallery-35.jpg`, `${ASSET}/gallery-48.jpg`, `${ASSET}/gallery-59.jpg`, `${ASSET}/gallery-67.jpg`, `${ASSET}/gallery-71.jpg`, `${ASSET}/gallery-75.jpg`, `${ASSET}/gallery-82.jpg`] },
];

export const galleryImages = [
  17, 23, 35, 48, 59, 67, 75, 82, 11, 22, 28, 41, 53, 62, 71
].map(n => `${ASSET}/gallery-${n}.jpg`);

export const chapters = [
  { name: 'Kerala (HQ)', city: 'Mavoor, Kozhikode', country: 'India' },
  { name: 'Dubai', city: 'Dubai', country: 'UAE' },
  { name: 'Abu Dhabi', city: 'Abu Dhabi', country: 'UAE' },
  { name: 'Sharjah', city: 'Sharjah', country: 'UAE' },
  { name: 'Riyadh', city: 'Riyadh', country: 'Saudi Arabia' },
  { name: 'Doha', city: 'Doha', country: 'Qatar' },
  { name: 'Kuwait City', city: 'Kuwait City', country: 'Kuwait' },
];

export const team = [
  { name: 'Fazil. AK', role: 'President', img: `${ASSET}/leadership/fazil-ak.png` },
  { name: 'Shahul Hameed. PK', role: 'Secretary', img: `${ASSET}/leadership/shahul-hameed-pk.png` },
  { name: 'Hussain Kutty. KK', role: 'Treasurer', img: `${ASSET}/leadership/hussain-kutty-kk.png` },
  { name: 'Rajesh. T', role: 'Vice President', img: `${ASSET}/leadership/rajesh-t.png` },
  { name: 'Rashid. P', role: 'Vice President', img: `${ASSET}/leadership/rashid-p.png` },
  { name: 'Nizamul Haque. VK', role: 'Joint Secretary', img: `${ASSET}/leadership/nizamul-haque-vk.png` },
  { name: 'Bineesh', role: 'Joint Secretary', img: `${ASSET}/leadership/bineesh.png` },
];

export const nav = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Vision & Mission', href: '/vision-mission' },
  { label: 'Events', href: '/events' },

  {
    label: 'More', children: [
      { label: 'REFOCC Women', href: '/women' },
      { label: 'REYOCC — Youth', href: '/reyocc' },
      { label: 'Vision REFOCC', href: '/vision-refocc' },
      { label: 'Gallery', href: '/gallery' },
      { label: 'Contact', href: '/contact' },
    ]
  },
];
